import { type TFunction } from "i18next";

import { WFPButton } from "@/components/ui/button";

import type { InfoHubSubjectRow, SubjectActions } from "../../types";
import { ChevronRight } from "lucide-react";

interface SubjectActionsCellProps {
  subject: InfoHubSubjectRow;
  actions: SubjectActions;
  isAllCountries: boolean;
  t: TFunction;
}

export const SubjectActionsCell = ({
  subject,
  actions,
  isAllCountries,
  t,
}: SubjectActionsCellProps) => {
  const { id, status } = subject;

  const buttons: { label: string; variant: "default" | "outline" | "link"; onClick: () => void }[] =
    [];

  if (isAllCountries) {
    if (status === "published") {
      buttons.push({
        label: t("infoHub.table.actions.copy"),
        variant: "outline",
        onClick: () => actions.copy(id),
      });
      buttons.push({
        label: t("infoHub.table.actions.view"),
        variant: "link",
        onClick: () => actions.view(id),
      });
    } else if (status === "withdrawn") {
      buttons.push({
        label: t("infoHub.table.actions.view"),
        variant: "outline",
        onClick: () => actions.view(id),
      });
    }
  } else {
    switch (status) {
      case "draft":
        buttons.push({
          label: t("infoHub.table.actions.publish"),
          variant: "default",
          onClick: () => actions.publish(id),
        });
        buttons.push({
          label: t("infoHub.table.actions.edit"),
          variant: "link",
          onClick: () => actions.edit(id),
        });
        break;
      case "published":
        buttons.push({
          label: t("infoHub.table.actions.view"),
          variant: "outline",
          onClick: () => actions.view(id),
        });
        break;
      case "withdrawn":
        buttons.push({
          label: t("infoHub.table.actions.view"),
          variant: "outline",
          onClick: () => actions.view(id),
        });
        buttons.push({
          label: t("infoHub.table.actions.resume"),
          variant: "link",
          onClick: () => actions.edit(id),
        });
        break;
    }
  }

  return (
    <div className="flex items-center justify-start gap-2">
      {buttons.map(button => (
        <WFPButton
          key={button.label}
          type="button"
          size="sm"
          variant={button.variant}
          onClick={button.onClick}
        >
          {button.label}
          <ChevronRight className="size-4" aria-hidden="true" />
        </WFPButton>
      ))}
    </div>
  );
};

export default SubjectActionsCell;
